import autosize from "autosize";
import { register } from "../app";

register(container => {
    container.querySelectorAll("textarea").forEach(el => {
        autosize(el);
    });
});
